import { defineStore } from 'pinia';
import api from '@/../lib/api';

export const useStylesStore = defineStore('styles', {
  state: () => ({
    stylesList: null,
    isLoading: false,
    status: '',
  }),
  actions: {
    async getStyles() {
      try {
        this.status = 'loading';
        this.isLoading = true;

        const { data } = await api.ai.getStyles();

        if (!data.success) {
          throw new Error();
        }

        this.status = 'success';
        this.stylesList = data.data;
      } catch (error) {
        this.status = 'error';
        this.stylesList = null;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
